import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-muted-foreground">
        Wird geladen …
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // BL-460/Stufe-1: MFA ist Pflicht -- ein Nutzer ohne 2FA kommt bis zur
  // Einrichtung (`/konto`) und nicht weiter. Spiegelt die Backend-Weiche
  // (middleware/auth.ts requireMfaEnrollment) auf Frontend-Seite: ohne
  // diesen Redirect würde jede andere Seite laden und erst bei der ersten
  // API-Anfrage mit MFA_SETUP_REQUIRED scheitern -- funktional korrekt, aber
  // eine schlechte Anzeige statt einer klaren Weiterleitung.
  if (!user.totpEnabled && location.pathname !== '/konto') {
    return <Navigate to="/konto" replace />;
  }

  return <>{children}</>;
}
